export const POST_TAB_REQUEST = '@@tabs/POST_TAB_REQUEST'